export const productColumns = [
  {
    id: "make",
    label: "Make",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "model",
    label: "Model",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "category",
    label: "Category",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "external_description",
    label: "External Description",
    editable: true,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "repairShopr_id",
    label: "RepairShopr ID",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "retail_price",
    label: "Retail Price",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "created_at",
    label: "Created At",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "updated_at",
    label: "Updated At",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tags",
    label: "Tags",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "name",
    label: "Name",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
];
